import { FeatureFlagOptions } from './types'

export const MAIN_CLAIM_V2_VARIANTS = {
  WITH_ELOQUENT_CALLOUT: 'with_eloquent_callout',
} as const

export const JURIS_DOCVIEW_REDESIGN_VARIANTS = {
  ENABLED: 'enabled',
} as const

export const GROWTH_BOOK_FEATURE_FLAGS: Record<string, FeatureFlagOptions> = {
  THESIS_SECURITY: {
    name: 'thesis_security_in_juris_docview',
    values: ['accordion', 'card'],
  },
  MAIN_CLAIM_V2: {
    name: 'juris_main_claim_v2',
    values: Object.values(MAIN_CLAIM_V2_VARIANTS),
  },
  JURIS_DOCVIEW_REDESIGN: {
    name: 'juris_docview_redesign',
    values: Object.values(JURIS_DOCVIEW_REDESIGN_VARIANTS),
  },
} as const
